<template>
  <div
    class="user-avatar-comp"
    :class="disableOpenLink ? '' : 'open-as-link'"
    v-if="user != null && user.id != null"
    @click="openUserInNewTab"
  >
    <!-- Email tooltip wrapper -->
    <v-tooltip
    top
    nudge-top="60"
    absolute
      content-class="user-email-tooltip"
      :attach="true"
      :disabled="!showEmailTooltip"
      
    >  
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" style="display: contents;">
          <v-btn
            v-if="closable"
            icon
            small
            class="close-btn"
            @click.stop="$emit('close')"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
          <!-- <v-scroll-x-transition mode="out-in" > -->
          <v-tooltip
            :top="!tooltipBottom"
            :bottom="tooltipBottom"
            :nudge-top="tooltipBottom ? 5 : -8"
            :disabled="!icon || noTooltip"
            key="user-circle-icon"
            z-index="100"
          >
            <template v-slot:activator="{ on: on2, attrs: attrs2 }">
              <div
                v-bind="attrs2"
                v-on="on2"
                class="user-circle"
                :style="{
                  color: avatarColor.fg,
                  backgroundColor: avatarColor.bg,
                  width: `${size}px`,
                  height: `${size}px`,
                }"
              >
                <img
                  v-if="user.avatarUrl && !imageFailed"
                  :alt="user.firstName + ' ' + user.lastName"
                  :src="user.avatarUrl"
                  class="user-image"
                  @error="imageFailed = true"
                />
                <span class="user-initials" :style="{ fontSize: `${initialsFontSize}px` }" v-text="initials"></span>
              </div>
            </template>
            <span style="z-index: 0">{{ fullName }}</span>
          </v-tooltip>
          <!-- </v-scroll-x-transition>
          <v-scroll-x-transition mode="out-in"> -->
          <span v-if="!icon" class="user-name-role" key="user-text">
            <span style="z-index: 0" class="user-fullName" v-text="fullName"></span>
            <span v-if="role && !hideRoles" class="user-role" v-text="role"></span>
          </span>
          <!-- </v-scroll-x-transition> -->
        </div>
      </template>
      <span>{{ userEmail }}</span>
    </v-tooltip>
  </div>
  <div class="user-avatar" v-else-if="user == null && showNoUser">
    <div
      class="user-circle"
      :style="{
        color: noUserAvatarColor.fg,
        backgroundColor: noUserAvatarColor.bg,
        width: `${size}px`,
        height: `${size}px`,
      }"
    >
      <span class="user-initials">
        <i
          class="fad"
          :class="
            noUserIcon == null || noUserIcon == ''
              ? 'fa-user-alt-slash'
              : noUserIcon
          "
        ></i>
      </span>
    </div>
    <span v-if="!icon" class="user-name-role">
      <span
        class="user-fullName text--disabled"
        v-text="noUserText == null || noUserText == '' ? 'No User' : noUserText"
      ></span>
    </span>
  </div>
</template>

<script>
import {
  getAvatarColors,
  getInitials,
  getNeutralAvatarColors,
} from "@/features/Share/utils/userAvatarPalette";

export default {
  name: "user-avatar",
  data() {
    return {
      // A photo that fails to load (expired SAS, storage offline) falls back to the initials.
      imageFailed: false,
    };
  },
  watch: {
    "user.avatarUrl"() {
      this.imageFailed = false;
    },
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    hideRoles: {
      type: Boolean,
      default: false,
    },
    disableOpenLink: {
      type: Boolean,
      default: false,
    },
    showNoUser: {
      type: Boolean,
      default: false,
    },
    noUserText: {
      type: String,
      default: null,
    },
    noUserIcon: {
      type: String,
      default: null,
    },
    tooltipBottom: {
      type: Boolean,
      default: false,
    },
    noTooltip: {
      type: Boolean,
      default: false,
    },
    noEmailTooltip: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 28,
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  computed: {
    isDark() {
      return Boolean(this.$vuetify && this.$vuetify.theme && this.$vuetify.theme.dark);
    },
    initials() {
      return getInitials(this.fullName);
    },
    initialsFontSize() {
      // ~39% of the circle keeps two letters balanced from 20px chips to 40px headers.
      return Math.max(9, Math.round(this.size * 0.39));
    },
    fullName() {
      return `${this.user.firstName || ""} ${this.user.lastName || ""}`.trim();
    },
    userEmail() {
      return this.user && this.user.email ? this.user.email : 'No email available';
    },
    showEmailTooltip() {
      return this.user && this.user.email && !this.noEmailTooltip;
    },
    role() {
      if (this.user.roles && this.user.roles.length > 0)
        return this.user.roles[0].name;
      else return null;
    },
    avatarColor() {
      const { bg, fg } = this.user == null
        ? getNeutralAvatarColors(this.isDark)
        : getAvatarColors(this.user.id, this.isDark);
      return { bg, fg };
    },
    noUserAvatarColor() {
      const { bg, fg } = getNeutralAvatarColors(this.isDark);
      return { bg, fg };
    },
  },
  methods: {
    openUserInNewTab(e) {
      if (this.disableOpenLink) return;

      e.stopPropagation();
      const path = `/users/${this.user.id}`;
      window.open(path, "_blank");
    },
  },
};
</script>

<style lang="scss">
.user-email-tooltip {
  z-index: 1000 !important;
  position: absolute;
  top:25px !important;
  left:25px !important;
}

.user-avatar-comp {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  position: relative;
  max-width: -webkit-fill-available;
  // padding: 0.25rem;
  cursor: pointer;

  &.open-as-link {
    border-radius: 0.25rem;
    transition: all 0.15s ease-out;
    cursor: pointer;

    &:hover {
      background: rgba(#fff, 0.04);
    }
  }

  .close-btn {
    position: absolute;
    right: -12px;
    top: -8px;
    z-index: 1;
    background: #f03434;
    color: #fff !important;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    min-width: 16px;
    box-shadow: 0 0 4px rgba(0,0,0,0.2);
    padding: 0px;

    &:hover {
      background: #fb2121;
    }
  }

  .user-circle {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    user-select: none;
    flex: none;
  }

  img.user-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    left: 0;
    top: 0;
  }
  span.user-initials {
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.02em;
    line-height: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  span.user-name-role {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    width: 85%;
  }

  span.user-fullName {
    font-weight: 500;
    font-size: 14px;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  span.user-role {
    font-weight: 600;
    font-size: 12px;
    color: var(--v-primary-base);
    line-height: 1;
    margin-top: 0.25rem;
  }
}
</style>
